import { generateCarleadCreationConfig } from '@wkda/funnel-utils';
import { DEFAULT_CARLEAD_CONFIGS } from '@wkda/marketing-components';

const extendedCarleadCreationConfig = {
  ...DEFAULT_CARLEAD_CONFIGS['de-DE'],
  marketingAttributes: {
    ...DEFAULT_CARLEAD_CONFIGS['de-DE'].marketingAttributes,
    'lead-conversational-lead-toggle': 0,
  },
};

export default generateCarleadCreationConfig(extendedCarleadCreationConfig);
